import React from 'react';
import { Redirect } from 'react-router-dom';

// User profile
import UserProfile from '../pages/Authentication/UserProfile';

// Users
import Users from '../pages/Users';

// MSAL
import MicrosoftAuthorize from '../pages/Microsoft/authorize';
import Microsoft from '../pages/Microsoft';

// Inventory
import Inventory from '../pages/Inventory/view';
import Inventories from '../pages/Inventory';

// Kits
import Kits from '../pages/Kits/index';
import KitView from '../pages/Kits/view';

// Printers
import Printers from '../pages/Printers';

// Order
import Orders from '../pages/Orders';
import Order from '../pages/Orders/view';
import PicklistPrint from '../pages/Orders/picklist-print';

// Slack
import Slack from '../pages/Slack';
import SlackApproval from '../pages/Slack/approve';

// Ship
import Ship from '../pages/Orders/ship';
import PayOnUse from '../pages/Orders/payonuse';

// Notifications
import Notify from '../pages/Notify';

// Client Api
import ClientApi from '../pages/ClientApi';
import Debug from '../pages/Debug';
import ShipMethodMappings from '../pages/Settings/ship-method-mappings';
import Scanners from '../pages/Settings/scanners';
import Boxes from '../pages/Utilities/boxes';

// Logs
import Exceptions from '../pages/Log/exceptions';
import ScrapRecordsPage from '../pages/Log/scrap';
import ShippingExceptions from '../pages/Log/shippingExceptions';
import AuditTrail from '../pages/Log/auditTrail';

// Authentication related pages
import Login from '../pages/Authentication/Login';
import NewPassword from '../pages/Authentication/NewPassword';
import Logout from '../pages/Authentication/Logout';

// Dashboard
import Dashboard from '../pages/Dashboard/index';
import Today from '../pages/Today';

// Warehouse
import Warehouse from '../pages/Warehouse/index';
import WarehouseMap from '../pages/Warehouse/map';
import InternalOrders from '../pages/Warehouse/internal-order';
import Pickroutes from '../pages/Warehouse/pickroutes';
import Pickroute from '../pages/Warehouse/pickroute';
import Inspect from '../pages/Warehouse/inspect';
import PackV2 from '../pages/Warehouse/pack-v2';

// Put-AWay
import PutAwayBins from '../pages/PutAway/bins';
import PutAwayRoutes from '../pages/PutAway/routes';
import PutAwayRoute from '../pages/PutAway/route';
import PutAwayLotMapping from '../pages/PutAway/lot-mapping';
import Consolidate from '../pages/PutAway/consolidate';

// Layouts
import PrintLayout from '../components/PrintLayout';
import TodayLayout from '../components/TodayLayout';
import { UTILITIES_ROLES } from '../helpers/authorization';

const authProtectedRoutes = [
  { path: '/dashboard', component: Dashboard },

  // profile
  { path: '/profile', component: UserProfile },

  // Logs
  { path: '/logs/exceptions', component: Exceptions },
  // Logs
  { path: '/logs/scrap', component: ScrapRecordsPage },
  { path: '/logs/shipping-exceptions', component: ShippingExceptions },
  { path: '/logs/audit-trail', component: AuditTrail },

  // Azure
  { path: '/microsoft', component: Microsoft },
  { path: '/microsoft/authorize', component: MicrosoftAuthorize },

  // Client API
  { path: '/client-api', component: ClientApi },
  { path: '/debug', component: Debug },

  // Users
  { path: '/users', component: Users },
  { path: '/settings/ship-method-mappings', component: ShipMethodMappings },
  { path: '/settings/scanners', component: Scanners },
  { path: '/utilities/boxes', component: Boxes, allowedRoles: UTILITIES_ROLES },

  // Inventory
  { path: '/inventory', component: Inventories },
  { path: '/inventory/:id', component: Inventory },
  { path: '/stock/:id', component: Inventory },

  // Kits
  { path: '/kits', component: Kits },
  { path: '/kits/:id', component: KitView },

  // Printers
  { path: '/printers', component: Printers },

  // Sales
  { path: '/orders', component: Orders },
  { path: '/orders/:id', component: Order },
  { path: '/orders/picklist/:id', component: PicklistPrint, layout: PrintLayout },

  // Slack
  { path: '/slack', component: Slack },
  { path: '/slack/approve', component: SlackApproval },

  // Ship
  { path: '/ship/payonuse', component: PayOnUse },
  { path: '/ship/:shipmentId?', component: Ship },

  // Notifications
  { path: '/notify', component: Notify },

  // Warehouse
  { path: '/warehouse', component: Warehouse, allowedRoles: UTILITIES_ROLES },
  { path: '/warehouse/map', component: WarehouseMap, allowedRoles: UTILITIES_ROLES },
  { path: '/warehouse/internal-orders', component: InternalOrders },
  { path: '/warehouse/pickroutes', component: Pickroutes },
  { path: '/warehouse/pickroute/:id', component: Pickroute },
  { path: '/warehouse/pack/v2', component: PackV2 },
  { path: '/warehouse/pack/v2/:urlOrderId', component: PackV2 },
  { path: '/warehouse/inspect', component: Inspect },

  // Put-Away
  { path: '/put-away/bins', component: PutAwayBins },
  { path: '/put-away/routes', component: PutAwayRoutes },
  { path: '/put-away/route/:id', component: PutAwayRoute },
  { path: '/put-away/lot-mapping', component: PutAwayLotMapping },
  { path: '/put-away/consolidate', component: Consolidate },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: '/', exact: true, component: () => <Redirect to="/dashboard" /> },
];

const publicRoutes = [
  { path: '/today', component: Today, layout: TodayLayout },
  { path: '/logout', component: Logout },
  { path: '/login', component: Login },
  { path: '/reset', component: NewPassword },
];

export { authProtectedRoutes, publicRoutes };
